module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"acquisition_year":"Acquisition year","acquisition_score":"Acquisition score","missing_date":"Missing date","catalog_year":"Catalog year","full_score":"Score","all":"All"},"cs":{"acquisition_year":"Rok akvizice","acquisition_score":"Akviziční skóre","missing_date":"Chybějící datum","catalog_year":"Rok katalogizace","full_score":"Skóre","all":"Všechny"}}')
  delete Component.options._Ctor
}
